<script setup lang="ts">
import dayjs from "dayjs";
// import { ref, computed } from "vue";
// import { useStore } from "vuex";
import { useToastStore } from "@/store/toast";
import { useRoute } from "vue-router";
import { useDefaultStore } from "@/store";
import { useTempStoreOptions } from "@/store/tempOptions";
import { parseErrors } from "@/assets/js/parseErrors";
import api from "@/api";

const defaultStore = useDefaultStore();
const systemPermissions = defaultStore.initialStatus;
const userStoreOpt = useTempStoreOptions();

const toast = useToastStore();
const route = useRoute();

// const store = useStore();
type TShift = {
	// NRML, ONCL, SLEP
	type: any; //"NRML" | "ONCL" | "SLEP";
	location: any;
	ward: any;
	grade: any;
	startTime: string;
	endTime: string;
	startDate: string;
	endDate: string;
	additionalTime: {
		isUsed: boolean;
		startTime?: string;
		endTime?: string;
		startDate: string | any;
		endDate: string | any;
	};
};
// const props = defineProps<{
// 	user: any;
// }>();

const emit = defineEmits(["close-modal", "confirm"]);

const shiftType = ref({
	regular: "NRML",
	standby: "ONCL",
	sleepover: "SLPO",
	sleepoverAwaken: "AWKE", // AWKE
});

const shiftId = computed(() => {
	return route.params.id;
});
const tempHasStandby = computed(() => {
	return (
		// this.$store.getters.agencyHasStandby && this.$store.getters.tempHasStandby
		// agencyHasStandby is same as can_use_on_call
		systemPermissions.can_use_on_call && userStoreOpt.tempHasStandby
	);
});
const tempHasSleepover = computed(() => {
	return (
		// this.$store.getters.agencyHasSleepover &&
		// this.$store.getters.tempHasSleepover
		// agencyHasSleepover is same as can_use_sleepover
		systemPermissions.can_use_sleepover && userStoreOpt.tempHasSleepover
	);
});
const isStandbyShift = computed(() => {
	return shift.value?.type?.code === shiftType.value.standby;
});
const isSleepoverShift = computed(() => {
	return shift.value?.type?.code === shiftType.value.sleepover;
});

// const arrShiftTypes = ref([
// 	{
// 		id: "regular",
// 		name: "Regular shift",
// 		code: "NRML",
// 	},
// 	{
// 		id:"standby", name :"Standby shift", code: "NRML"
// 	},
// 	{
// 		id:"sleepover", name :"Sleepover shift", code: "NRML"
// 	},
// ]);

const arrShiftTypesShow = computed(() => {
	const arr = [
		{
			id: "regular",
			name: "Regular shift",
			code: "NRML",
		},
	];
	if (tempHasStandby && locationHasStandby) {
		arr.push({
			id: "standby",
			name: "Standby shift",
			code: "ONCL",
		});
	}
	if (tempHasSleepover && locationHasSleepover.value) {
		arr.push({
			id: "sleepover",
			name: "Sleepover shift",
			code: "SLPO",
		});
	}
	return arr;
});

// Reactive state
const refreshTime = ref(true);
const locationReload = ref(true);
const wardReload = ref<any>(true);
const weekEarlier = ref(new Date(new Date().setDate(new Date().getDate() - 8)));
const canAddSpecialNote = ref(false);
const clientNote = ref("");

const selectedShift = ref<any>({
	type: "",
	locId: null,
	wardId: null,
	gradeId: null,
	startTime: "00:00",
	endTime: "00:00",
	startDate: null,
	endDate: null,
});

// const calendarStart = ref<any>(null);
// const calendarEnd = ref<any>(null);
const locations = ref<any[]>([]);
const wards = ref<any[]>([]);
const grades = ref<any[]>([]);

const shift = ref<TShift>({
	// NRML, ONCL, SLEP
	type: "NRML",
	location: null,
	ward: null,
	grade: null,
	startTime: "00:00",
	endTime: "00:00",
	startDate: null,
	endDate: null,
	additionalTime: {
		isUsed: false,
		// startTime: "00:00",
		// endTime: "00:00",
		startDate: dayjs().startOf("day"),
		endDate: dayjs().startOf("day"),
	},
});

const error = ref({
	location: false,
	ward: false,
	grade: false,
	startDate: false,
	endDate: false,
	startTime: false,
	endTime: false,
});

// const activeStatus = ref<number | null>(null);

// Computed properties

const locationHasStandby = computed(() => {
	if (shift.value?.ward?.hasOnCall) return true;
	return false;
});

const locationHasSleepover = computed(() => {
	if (shift.value?.ward?.hasSleepover) return true;
	return false;
});

const additionalTimeTitle = computed(() => {
	switch (shift.value.type?.code) {
		case shiftType.value.sleepover: {
			return "Sleeping Time";
			break;
		}
		case shiftType.value.standby: {
			return "On Call";
			break;
		}
		default: {
			return;
			break;
		}
	}
});

const checkStandyRule = computed(() => {
	// on the mobile application this condition is used
	// return shift.value.type === shiftType.value.standby ? new Date() : null;
	return shift.value.type === shiftType.value.standby ? true : false;
});
const canSetOnCall = computed(() => {
	let startDate = null;
	const today = dayjs();
	if (shift.value.startDate) {
		startDate = dayjs(shift.value.startDate);
	}
	if (startDate === null) return false;
	if (startDate.isAfter(today, "day")) return false;
	if (startDate.isSame(today, "day")) return true;
	return true;
});

// methods

function setShiftType(type, from) {
	if (
		(type === "sleepover" && shift.value.ward?.hasSleepover) ||
		(type === "standby" && shift.value.ward?.hasOnCall) ||
		type === "regular"
	) {
		shift.value.type = shiftType.value[type];
	} else
		console.log(
			"Didnt change shift type due to ward not having enabled specified shift",
		);
	console.log(shift.value.type, shift.value, from);
}
function callHandleError(err: any) {
	const errors = parseErrors(err);
	if (Array.isArray(errors) && errors.length > 0) {
		errors.map((e) => {
			toast.openToastError(e);
		});
	} else if (errors) {
		toast.openToastError(errors);
	}
}

async function init() {
	try {
		await fetchLocations();
		await checkAndFetchShift();
		// console.log(this.selectedShift);
		// datePickerSetup();
	} catch (error) {
		console.warn(error);
		callHandleError(error);
	}
	// console.log(this.shiftId);
}

async function fetchLocations() {
	try {
		const res = await api.getLocationAndCategory();
		formatLocation(res.data.data);
	} catch {}
}
async function checkAndFetchShift() {
	const id = Number(shiftId.value);
	if (id) {
		const res = await api.showShift(id);
		console.log(res.data.data);
		const r = res.data.data;
		selectedShift.value = {
			type: r.type,
			startDate: dayjs(r.startTime.date).format("YYYY-MM-DD"),
			startTime: dayjs(r.startTime.date).format("HH:mm"),
			endDate: dayjs(r.endTime.date).format("YYYY-MM-DD"),
			endTime: dayjs(r.endTime.date).format("HH:mm"),
			locId: r.location.client.id,
		};

		if (r.location.client.locations.length)
			selectedShift.value.wardId = r.location.client.locations[0].id;
		if (r.shiftRequest.subcategories.length)
			selectedShift.value.gradeId = r.shiftRequest.subcategories[0].id;

		startTimeSetter(dayjs(r.startTime.date).format("HH:mm:ss"));
		endTimeSetter(dayjs(r.endTime.date).format("HH:mm:ss"));
		refreshTime.value = false;
		nextTick(() => {
			refreshTime.value = true;
		});

		autoCopy();

		if (
			selectedShift.value.wardId &&
			selectedShift.value.gradeId &&
			r.type === shiftType.value.standby
		)
			setShiftType("standby", "after autocopy");
		if (
			selectedShift.value.wardId &&
			selectedShift.value.gradeId &&
			r.type === shiftType.value.sleepover
		)
			setShiftType("sleepover", "after autocopy");
	}
}

// function datePickerSetup() {
// 	let today = new Date();
//  var weekEarlier = new Date().setDate(today.getDate() - 8);
//   this.calendarStart = this.$f7.calendar.create({
//     closeOnSelect: true,
//     inputEl: "#calendar-start",
//     dateFormat: "dd-mm-yyyy",
//     disabled: {
//       to: weekEarlier,
//     },
//   });
//   this.calendarEnd = this.$f7.calendar.create({
//     closeOnSelect: true,
//     inputEl: "#calendar-end",
//     dateFormat: "dd-mm-yyyy",
//     disabled: {
//       to: weekEarlier,
//     },
//   });
// }

function generatFromVal(i) {
	return {
		target: {
			value: i,
		},
	};
}

function autoCopy() {
	resetLocation();
	for (let i = 0; i < locations.value.length; i++) {
		const loc = locations.value[i];
		if (loc.id == selectedShift.value.locId) {
			shift.value.location = loc;
			const val = generatFromVal(i);
			inputLocation(val);
			break;
		}
	}
	if (shift.value.location && shift.value.location.locations?.length)
		for (let i = 0; i < shift.value.location.locations.length; i++) {
			const ward = shift.value.location.locations[i];
			if (ward.id == selectedShift.value.wardId) {
				shift.value.ward = ward;
				const val = generatFromVal(i);
				inputWard(val);
				break;
			}
		}

	if (
		shift.value.ward &&
		shift.value.ward.subcategories &&
		shift.value.ward.subcategories.length
	)
		for (let i = 0; i < shift.value.ward.subcategories.length; i++) {
			const grade = shift.value.ward.subcategories[i];
			if (grade.id == selectedShift.value.gradeId) {
				shift.value.grade = grade;
				const val = generatFromVal(i);
				inputGrade(val);
				break;
			}
		}
}

function formatLocation(data) {
	locations.value = data;
	if (locations.value.length === 1) {
		const val = generatFromVal(0);
		inputLocation(val);
	}
}
function formatWard() {
	console.log("shift.value.location)", shift.value.location);
	wards.value = shift.value.location?.locations; // locations arr which references on wards
	grades.value = [];
	if (wards.value.length === 1) {
		const val = generatFromVal(0);
		inputWard(val);
	}
}
function formatGrade() {
	console.log(shift.value.ward);
	grades.value = shift.value.ward?.subcategories; // subcategories arr which references on grades
	if (grades.value.length === 1) {
		const val = generatFromVal(0);
		inputGrade(val);
	}
}

function inputLocation(e) {
	console.log(e);

	shift.value.location = e; // locations.value[Number(e.target.value)];
	shift.value.ward = null;
	shift.value.grade = null;
	canAddSpecialNote.value = false;
	formatWard();
	resetWard();
	removeAllErrors();
	setShiftType("regular", "from wardchange");
}

function inputWard(e, manualInput = false) {
	manualInput
		? (shift.value.ward = e)
		: (shift.value.ward =
				shift.value.location.locations[Number(e.target.value)]);
	shift.value.grade = null;
	canAddSpecialNote.value = false;
	formatGrade();

	if (manualInput) {
		selectedShift.value.gradeId = null;
		setShiftType("regular", "from wardchange");
	}
	error.value.ward = false;
}

async function inputGrade(e, manualInput = false) {
	// console.log("e", e);
	// console.log('---------- INPUT GRADE ----------');
	// console.log(this.shift.ward.subcategories);
	// console.log(Number(e.target.value));
	// console.log('---------- INPUT GRADE ----------');
	// this.selectedShift.gradeId = null
	// up old
	// console.log(shift.value.ward.subcategories);
	manualInput
		? (shift.value.grade = e)
		: (shift.value.grade =
				shift.value.ward.subcategories[Number(e.target.value)]);
	error.value.grade = false;

	let res: any = null;
	try {
		const result = await api.get_temp_calendar_config(
			shift.value.grade?.cat_id,
		);
		res = result.data.data;
	} catch (error) {
		console.warn(error);
		res = null;
	}

	res && res?.shift_start_not_before_date
		? (weekEarlier.value = new Date(res.shift_start_not_before_date))
		: (weekEarlier.value = new Date(
				new Date().setDate(new Date().getDate() - 8),
			));
	// weekEarlier.value.setDate(weekEarlier.value.getDate() - 1);

	res && res?.can_add_special_note
		? (canAddSpecialNote.value = true)
		: (canAddSpecialNote.value = false);
}

watch(
	() => shift.value.grade,
	(newVal) => {
		if (newVal) error.value.grade = false;
	},
);

function resetLocation() {
	locationReload.value = false;
	nextTick(() => {
		locationReload.value = true;
	});
}

function resetWard() {
	wardReload.value = false;
	nextTick(() => {
		wardReload.value = true;
	});
}

function startTimeSetter(val) {
	if (val === "") {
		error.value.startTime = true;
		return;
	}
	error.value.startTime = false;
	let final = val;
	if (val.length == 5) final += ":00";
	shift.value.startTime = final;
}

function endTimeSetter(val) {
	if (val === "") {
		error.value.endTime = true;
		return;
	}
	error.value.endTime = false;
	let final = val;
	if (val.length == 5) final += ":00";
	shift.value.endTime = final;
}
function removeAllErrors() {
	const errors = [
		"location",
		"ward",
		"grade",
		"startDate",
		"endDate",
		// "startTime",
		// "endTime",
	];
	for (const err of errors) {
		removeError(err);
	}
}
function removeError(el) {
	error.value[el] = false;
}
function checkForErrors() {
	let killed = false;
	// let kill = (el) => {
	// 	this.$set(this.error, el, true);
	// 	killed = true;
	// };
	const kill = (el) => {
		error.value[el] = true; // Vue 3's reactivity handles this natively
		killed = true;
	};
	const s = shift.value;
	// console.log(s);
	if (s.location === "" || !s.location) kill("location");
	if (s.ward === "" || !s.ward) kill("ward");
	if (s.grade === "" || !s.grade) kill("grade");
	if (s.startTime === "" || !s.startTime) kill("startTime");
	if (s.endTime === "" || !s.endTime) kill("endTime");
	if (s.startDate === "" || !s.startDate) kill("startDate");
	if (s.endDate === "" || !s.endDate) kill("endDate");

	return killed;
}

// function handleOutput(val, type) {
// 	// onCall: {
// 	//   startTime: null,
// 	//   endTime: null,
// 	//   startDate: null,
// 	//   endDate: null
// 	// }
// 	let getDateFromCalendar = (cal) => {
// 		console.log(cal.$inputEl[0].value);
// 		return cal.$inputEl[0].value;
// 	};
// 	switch (type) {
// 		case "onCallStartDate":
// 			shift.value.additionalTime.startDate = getDateFromCalendar(val);
// 			break;

// 		case "onCallStartTime":
// 			shift.value.additionalTime.startTime = val;
// 			break;

// 		case "onCallEndDate":
// 			shift.value.additionalTime.endDate = getDateFromCalendar(val);
// 			break;

// 		case "onCallEndTime":
// 			shift.value.additionalTime.endTime = val;
// 			break;

// 		default:
// 			break;
// 	}
// }
///
async function prepareForSubmitShift() {
	removeAllErrors();
	// let start = document.querySelector("#calendar-start").value;
	// let end = document.querySelector("#calendar-end").value;
	// shift.value.startDate = start;
	// shift.value.endDate = end;
	const err = checkForErrors();
	if (err) {
		toast.openToastError("Please fill all fields.");
		return;
	} else {
		await submitShift();
	}
}
// function changeIsUsed(e) {
// 	shift.value.additionalTime.isUsed = e.target.checked;
// }

// function formatDateForServer(date) {
// 	let allowedFormats = ["YYYY-MM-DD", "DD-MM-YYYY"];
// 	let newDate = dayjs(date, allowedFormats).format("YYYY-MM-DD");
// 	return newDate;
// }
// function formatTimeForServer(time) {
// 	let allowedFormats = ["HH:mm", "hh:mm:ss"];
// 	let newTime = dayjs(time, allowedFormats).format("HH:mm:ss");
// 	return newTime;
// }
async function submitShift() {
	const shiftL: any = {
		location_id: Number(shift.value.ward.id),
		subcategory_id: Number(shift.value.grade.id),
		start_time: shift.value.startDate, // `${formatDateForServer(shift.value.startDate)} ${formatTimeForServer(shift.value.startTime)}`,
		end_time: shift.value.endDate, // `${formatDateForServer(shift.value.endDate)} ${formatTimeForServer(shift.value.endTime)}`,
		shift_type: shift.value.type?.code,
	};
	if (
		(isStandbyShift.value || isSleepoverShift.value) &&
		shift.value.additionalTime.isUsed
	) {
		console.log(shift.value.additionalTime);
		shiftL.shift_parts = [];
		const shiftPart: any = {
			from: shift.value.additionalTime?.startDate, // `${formatDateForServer(shift.value.additionalTime?.startDate)} ${formatTimeForServer(shift.value.additionalTime?.startTime)}`,
			to: shift.value.additionalTime?.endDate, // `${formatDateForServer(shift.value.additionalTime?.endDate)} ${formatTimeForServer(shift.value.additionalTime?.endTime)}`,
		};
		if (isStandbyShift.value) shiftPart.type = shiftType.value.standby;
		if (isSleepoverShift.value) shiftPart.type = shiftType.value.sleepover;

		shiftL.shift_parts.push(shiftPart);
	}
	if (canAddSpecialNote.value && clientNote.value.length > 0) {
		shiftL.special_shift_name = clientNote.value;
	}
	try {
		await api.createShift(shiftL);
		toast.openToastSuccess("Your shift will be reviewed soon.");
		emit("close-modal");
		emit("confirm");
	} catch (error) {
		console.log(error);
		callHandleError(error);
	}
}

function displayExplanation() {
	if (canSetOnCall.value || isSleepoverShift.value) return;
	if (shift.value.startDate === null) {
		toast.openToastWarning("Please enter standby date first.");

		return;
	}
	toast.openToastWarning("You cannot set on call times in the future.");
}

// function reformatDateString(dateString) {
// 	const dateParts = dateString.split("-");
// 	return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
// }

function setStartDate(e: any) {
	console.log(e);
	error.value.startDate = false;
	// shift.value.startDate = e;
	// this.canSetOnCall();
}

onMounted(() => {
	init();
	userStoreOpt.getUserProfile();
});

// not done
// const updateStatus = async ({ id }: { id: number }) => {
// 	if (id === 3) {
// 		emit("confirm", props.user, 3); // deactivate
// 	} else if (id === 1) {
// 		emit("confirm", props.user, 1); // activate
// 	}
// 	emit("close-modal");
// };
</script>

<template>
	<div
		class="dialog-container"
		data-cell="edit-user-status"
		@click.stop=""
	>
		<div class="wrapp-inputs">
			<div
				v-if="locationReload"
				class="flex-column-start"
			>
				<label class="label">Location</label>
				<multiselect-form
					v-if="locationReload"
					v-model="shift.location"
					:options="locations"
					label="name"
					placeholder="Pick a location"
					value-prop="id"
					:multiple="false"
					:showLabels="true"
					:searchable="true"
					:style="{ 'border-color': error.location ? '#b93733' : '' }"
					@select="inputLocation"
				/>
				<span
					v-if="error.location"
					class="error-text"
				>
					<!-- {{ error.location }} -->
				</span>
			</div>
			<div
				v-if="wardReload"
				class="flex-column-start"
			>
				<label class="label">Ward</label>
				<multiselect-form
					v-model="shift.ward"
					:options="wards"
					label="name"
					placeholder="Pick a ward"
					value-prop="id"
					:multiple="false"
					:showLabels="true"
					:searchable="true"
					:style="{ 'border-color': error.ward ? '#b93733' : '' }"
					@select="inputWard($event, true)"
				/>
			</div>
			<div
				v-if="
					(tempHasStandby && locationHasStandby) ||
					(tempHasSleepover && locationHasSleepover)
				"
				class="flex-column-start"
			>
				<label class="label">Type</label>
				<multiselect-form
					v-model="shift.type"
					:options="arrShiftTypesShow"
					label="name"
					placeholder="Select shift type"
					value-prop="id"
					:multiple="false"
					:showLabels="true"
					:searchable="true"
				/>
				<!-- @select="setShiftType($event.target.value, 'template input')" -->
			</div>
			<!-- Grade -->
			<div class="flex-column-start">
				<label class="label">Grade</label>
				<multiselect-form
					v-model="shift.grade"
					:options="grades"
					label="name"
					placeholder="Pick a grade"
					value-prop="id"
					:multiple="false"
					:showLabels="true"
					:searchable="true"
					:style="{ 'border-color': error.grade ? '#b93733' : '' }"
					@select="inputGrade($event, true)"
				/>
				<!-- @select="inputGrade" -->
			</div>

			<!-- Start time-->
			<div class="flex-column-start">
				<label class="label">Start</label>
				<!-- v-model="start_time" -->
				<modern-date-picker
					v-model="shift.startDate"
					placeholder="Start Date/Time"
					:clearable="false"
					:enable-time-picker="true"
					format="dd/MM/yyyy, HH:mm"
					outputFormatString="YYYY-MM-DD HH:mm:ss"
					:min-date="weekEarlier"
					:class="{ error: error.startDate }"
					@update:model-value="setStartDate"
				/>
			</div>

			<!-- End time  -->
			<div class="flex-column-start">
				<label class="label">End</label>
				<!-- v-model="start_time" -->
				<modern-date-picker
					v-model="shift.endDate"
					placeholder="End Date/Time"
					:clearable="false"
					:enable-time-picker="true"
					format="dd/MM/yyyy, HH:mm"
					outputFormatString="YYYY-MM-DD HH:mm:ss"
					:min-date="weekEarlier"
					:class="{ error: error.endDate }"
					@update:model-value="error.endDate = false"
				/>
			</div>
			<!-- checkbox -->
			<div
				v-if="isStandbyShift || isSleepoverShift"
				class="flex-column-start"
			>
				<label
					class="label"
					@click="displayExplanation"
				>
					<input
						v-if="canSetOnCall || isSleepoverShift"
						v-model="shift.additionalTime.isUsed"
						type="checkbox"
						style="margin-left: 10px"
					/>
					<input
						v-else
						:indeterminate="true"
						type="checkbox"
						style="margin-left: 10px"
						disabled
					/>
					{{ additionalTimeTitle }}
				</label>

				<!-- Start time-->

				<div
					v-if="canSetOnCall || isSleepoverShift"
					class="flex-column-start"
				>
					<label class="label">Start</label>
					<!-- v-model="start_time" -->
					<modern-date-picker
						v-model="shift.additionalTime.startDate"
						:defaultDate="new Date().toString()"
						placeholder="Start Date/Time"
						:clearable="false"
						:enable-time-picker="true"
						format="dd/MM/yyyy, HH:mm"
						outputFormatString="YYYY-MM-DD HH:mm:ss"
						:disabled="!shift.additionalTime.isUsed || checkStandyRule"
						:min-date="weekEarlier"
					/>
				</div>

				<!-- End time  -->
				<div
					v-if="canSetOnCall || isSleepoverShift"
					class="flex-column-start"
				>
					<label class="label">End</label>
					<!-- v-model="start_time" -->
					<modern-date-picker
						v-model="shift.additionalTime.endDate"
						placeholder="End Date/Time"
						:clearable="false"
						:enable-time-picker="true"
						format="dd/MM/yyyy, HH:mm"
						outputFormatString="YYYY-MM-DD HH:mm:ss"
						:disabled="!shift.additionalTime.isUsed || checkStandyRule"
						:min-date="weekEarlier"
					/>
				</div>
			</div>
			<div
				v-if="canAddSpecialNote"
				class="note-content-wrap"
			>
				<label class="label">Add note</label>
				<div class="note-input-area">
					<textarea
						v-model="clientNote"
						style="width: 100%; padding-left: 12px"
						placeholder="Type here..."
					></textarea>
				</div>
			</div>
		</div>

		<div class="buttons-centered">
			<button
				class="button is-small alt"
				data-cell="cancel-button"
				@click.prevent="emit('close-modal')"
			>
				Cancel
			</button>
			<button
				class="button"
				@click="prepareForSubmitShift"
			>
				Submit shift
			</button>
		</div>
	</div>
</template>
<style lang="scss" scoped>
.dialog-container {
	width: 100%;
	box-sizing: border-box;
	padding: 0 20px 20px;
	min-width: 564px;
	min-height: 500px;
	max-height: 590px;
	overflow: auto;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.wrapp-inputs {
	// width: 100%;
}
.inputs {
	display: flex;
	justify-content: center;

	.field {
		width: 100%;
	}
}
.error {
	border-color: $error-color !important;
}

.buttons-centered {
	display: flex;
	justify-content: center;
	align-items: center;

	button.button {
		margin: 17px 0.3em;
		min-width: 90px;
		height: 30px;
	}
}
.label {
	color: $label-accent-color;
	text-align: right;
	// width: 40px;
	margin-top: 5px;
	margin-right: 10px;
}
</style>
